module.exports = __webpack_public_path__ + "static/media/cousins2017.291f4e32.png";